import api from './index';

// 获取当前登录账号的基础资料
export function getCurrentProfile() {
    return api.get('/web/login/profile');
}

// 分页查询客户
export function fetchCustomers(params) {
    return api.post('/web/customers/page', params);
}

// 新增客户
export function addCustomer(data) {
    return api.post('/web/customers/add', data);
}

// 修改客户
export function updateCustomer(data) {
    return api.put('/web/customers/update', data);
}

// 删除客户
export function deleteCustomer(customerId) {
    return api.delete(`/web/customers/${customerId}`);
}

//邀请2.0
export const inviteInspector = (data) => {
    return api.post('/web/login/invite', data); // 确保路径与后端一致
};










